import { Component, Input, OnInit } from '@angular/core';
declare var $: any;
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgentService } from '@app/agent/services/agent.service';
@Component({
  selector: 'app-cancel-booking-modal',
  templateUrl: './cancel-booking-modal.component.html',
  styleUrls: ['./cancel-booking-modal.component.scss']
})
export class CancelBookingModalComponent implements OnInit {
  @Input() cancelBookingRowData: any;
  isLoading: boolean = false;

  constructor(private agentService: AgentService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }
  confirmCancelBooking() {
    if (this.cancelBookingRowData) {
      this.isLoading = true;
      this.agentService.cancelBooking(this.cancelBookingRowData.reference).subscribe((res: any) => {
        this.isLoading = false;
        $('#cancelBooking_Modal').modal('hide');
        $('#cancelBooking_ModalpopUp').modal('hide');
        this._snackBar.open(res.message, 'X');
      },(error:any)=>{
        this.isLoading = false; 
        $('#cancelBooking_Modal').modal('hide');
        $('#cancelBooking_ModalpopUp').modal('hide');
        this._snackBar.open('Something went wrong.Please try again later.', 'X');
      });
    }
  }
}
